import { ContentDelete } from '@fs/zion-icon/dist/cjs/icons'
import { useOverlay, DangerButton } from '@fs/zion-ui'
import React, { useContext } from 'react'
import { useTranslation } from 'react-i18next'
import { PermissionsContext } from '../../app/PermissionsContext'
import CmisDeleteDialog from './CmisDeleteDialog'

export default function CmisDeleteButton({ refIds, fetchCurrentPersonUser }) {
  const overlay = useOverlay()
  const { isAuthorized } = useContext(PermissionsContext)
  const { t } = useTranslation()
  return (
    <>
      <DangerButton
        Icon={ContentDelete}
        onClick={overlay.handleClick}
        disabled={
          Array.isArray(refIds)
            ? refIds.length === 0 || !isAuthorized('ManageCmisReferencePermission')
            : !isAuthorized('ManageCmisReferencePermission')
        }
      >
        {Array.isArray(refIds) ? t('action.deleteSelected', 'Delete Selected') : t('action.delete', 'Delete')}
      </DangerButton>
      <CmisDeleteDialog
        refIds={Array.isArray(refIds) ? refIds : [refIds]}
        fetchCurrentPersonUser={fetchCurrentPersonUser}
        {...overlay}
      />
    </>
  )
}
